import { render, staticRenderFns } from "./Reserve.vue?vue&type=template&id=22965a54&scoped=true"
import script from "./Reserve.vue?vue&type=script&lang=js"
export * from "./Reserve.vue?vue&type=script&lang=js"
import style0 from "./Reserve.vue?vue&type=style&index=0&id=22965a54&prod&scoped=true&lang=css"
import style1 from "./Reserve.vue?vue&type=style&index=1&id=22965a54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22965a54",
  null
  
)

export default component.exports